import { useState, useEffect } from "react";
import axios from "axios";
import { API, AFFILIATE_DEFAULT } from "./config";

export function useSettings() {
  const [settings, setSettings] = useState({ affiliate_url: AFFILIATE_DEFAULT });
  useEffect(() => {
    axios.get(`${API}/settings`).then(r => setSettings(r.data)).catch(() => {});
  }, []);
  return settings;
}

export function getAffiliate(settings) {
  return settings?.affiliate_url || AFFILIATE_DEFAULT;
}
